import React, { useEffect, useRef, useState } from 'react'
import MenuItem from './MenuItem'

const Menu = (props) => {
  const { items, onSelectedItem } = props
  const [selectedItem, setSelectedItem] = useState(null)
  const menuItemsRef = useRef()
  const selectedItemRef =
    menuItemsRef.current && selectedItem
      ? menuItemsRef.current.querySelector(`[data-slug=${selectedItem.slug}]`)
      : null

  const calculateDashPosition = (element, dashWidth) => {
    return element.offsetLeft + element.offsetWidth / 2 - dashWidth / 2
  }

  const calculateDashWidth = (element) => {
    return element.offsetWidth
  }

  const dashWidth = selectedItemRef ? calculateDashWidth(selectedItemRef) : 0

  const dashPosition = selectedItemRef ? calculateDashPosition(selectedItemRef, dashWidth) : 0

  const selectItem = (item) => {
    setSelectedItem(item)
    onSelectedItem(item)
  }

  useEffect(() => {
    const initialItem = items[0]
    setSelectedItem(initialItem)
  }, [items])

  const renderItems = items.map((item) => (
    <MenuItem
      item={item}
      selected={selectedItem && selectedItem.slug === item.slug}
      onItemSelect={selectItem}
    />
  ))

  return (
    <div className='menu'>
      <div className='menu_items' ref={menuItemsRef}>
        {renderItems}
        <div
          className='menu-dash'
          style={{
            width: `${dashWidth/14}rem`,
            transform: `translate3d(${dashPosition/14}rem, 0 , 0)`,
          }}
        />
      </div>
    </div>
  )
}
export default Menu
